import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

function MasterValueModal({ show, onClose, onSubmit, initialValue, typeName }) {
  const [form, setForm] = useState({
    ValueKey: '',
    ValueName: '',
    DisplayName: '',
    Description: '',
    SortOrder: 0,
    IsActive: true
  });

  useEffect(() => {
    if (initialValue) {
      setForm({
        ValueKey: initialValue.ValueKey || '',
        ValueName: initialValue.ValueName || '',
        DisplayName: initialValue.DisplayName || '',
        Description: initialValue.Description || '',
        SortOrder: initialValue.SortOrder || 0,
        IsActive: initialValue.IsActive === 1 || initialValue.IsActive === true
      });
    } else {
      setForm({ ValueKey: '', ValueName: '', DisplayName: '', Description: '', SortOrder: 0, IsActive: true });
    }
  }, [initialValue]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{initialValue ? `Edit ${typeName} Value` : `Add ${typeName} Value`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={submit}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Value Key</label>
                <input type="text" name="ValueKey" value={form.ValueKey} onChange={handleChange} className="form-control" required />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Value Name</label>
                <input type="text" name="ValueName" value={form.ValueName} onChange={handleChange} className="form-control" required />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Display Name</label>
                <input type="text" name="DisplayName" value={form.DisplayName} onChange={handleChange} className="form-control" required />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Sort Order</label>
                <input type="number" name="SortOrder" value={form.SortOrder} onChange={handleChange} className="form-control" />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label>Description</label>
                <textarea name="Description" value={form.Description} onChange={handleChange} className="form-control" rows={2} />
              </div>
            </div>
            <div className="col-md-12 mt-2">
              <div className="form-check">
                <input type="checkbox" id="IsActive" name="IsActive" className="form-check-input" checked={!!form.IsActive} onChange={handleChange} />
                <label className="form-check-label" htmlFor="IsActive">Active</label>
              </div>
            </div>
          </div>
          <div className="mt-3 d-flex justify-content-end">
            <button type="button" className="btn btn-secondary me-2" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary">{initialValue ? 'Update' : 'Add'}</button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default MasterValueModal;
